var OSS = require('ali-oss');

export function client() {
  const client = new OSS({
    region: 'oss-cn-hangzhou',
    accessKeyId: 'LTAI5t8CctpYgPCddVeMRSM2', // Note: Should use environment variables in production
    accessKeySecret: 'h7QMmbHgab6RY9SObNrSg7H0QW8RvR', // Note: Should use environment variables in production
    bucket: 'ahhzy',
    secure: true, // Force HTTPS
    cname: false, // Disable custom domain if not using one
    endpoint: 'https://oss-cn-hangzhou.aliyuncs.com' // Explicit HTTPS endpoint
  });
  return client;
}



// WEBPACK FOOTER //
// ./src/common/js/alioss.js